import script from "./Content.vue?vue&type=script&setup=true&lang=ts"
export * from "./Content.vue?vue&type=script&setup=true&lang=ts"

import "./Content.vue?vue&type=style&index=0&id=78b9420e&lang=scss&scoped=true"

import exportComponent from "/var/www/digital-card-solution-limited/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78b9420e"]])

export default __exports__